import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { addDisplayName } from "../Infra/display-name";
import { PageWithFixedHeaderAndFooterContent, PatientConsentParent } from "./PatientConsentManagerShared.styles";
import { useViewModel } from "./useViewModel";
import { ScreenshotReadinessDetector } from "./ScreenshotReadinessDetector";
import { PatientConsentSetupCompletionViewModel } from "./PatientConsentSetupCompletionViewModel";
import { AccountSetupCompletionView } from "./AccountSetupCompletionView";
export const PatientConsentSetupCompletionView = observer((props) => {
    const model = useViewModel(PatientConsentSetupCompletionViewModel, props.container);
    const webAddress = props.container.environment.WEBSITE_BASE_URL;
    return (_jsx(ScreenshotReadinessDetector, { isScreenshotMode: model.isScreenshotMode, children: _jsx(PageWithFixedHeaderAndFooterContent, { isHeaderAndFooterFixed: model.isHeaderAndFooterFixed, children: _jsx(PatientConsentParent, { children: _jsx(AccountSetupCompletionView, { model: model, webAddress: webAddress, animate: false }) }) }) }));
});
addDisplayName(PatientConsentSetupCompletionView, "PatientConsentSetupCompletionView");
